import { UtilsEnum } from '@/utils/UtilsEnum';

export const CENTRAL_REPROCESSAMENTO_ERRO_ENUM = UtilsEnum.create({
  SOLICITACAO_SEM_RESPOSTA: {
    value: 'SOLICITACAO_SEM_RESPOSTA',
    description: 'Solicitação sem resposta',
  },
  TIMEOUT: { value: 'TIMEOUT', description: 'Timeout' },
  MEMORIA_INSUFICIENTE: { value: 'MEMORIA_INSUFICIENTE', description: 'Memória insuficiente' },
  EXECUCOES_PARALELAS: {
    value: 'EXECUCOES_PARALELAS',
    description: 'Múltiplos reprocessamentos em execução para nrInsc',
  },
  ERRO_INESPERADO: { value: 'ERRO_INESPERADO', description: 'Erro inesperado' },
});
